// extracted by mini-css-extract-plugin
module.exports = {"whyMizar":"About_whyMizar__26yCW","quotes":"About_quotes__Ty8vz","quotesSmall":"About_quotesSmall__48Yoo"};